import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-row container" }

import { parseError } from "@/common/util";
import { useReportStore } from "@/stores/report";
import { showToastError } from "@/toastification";
import { reactive } from "vue";
import LoadingDownloadScreen from "@/components/util/LoadingDownloadScreen.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'R06View',
  setup(__props) {

const state = reactive({
    date: (new Date()).getFullYear(),
    showLoading: false,
});

const reportStore = useReportStore();

async function getReport() {
    state.showLoading = true;
    try {
        await reportStore.downloadR06(state.date);
    }
    catch (e) {
        console.error(e);
        showToastError("Report was unable to generate: " + parseError(e));
    }
    finally {
        state.showLoading = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Get report for selected year (R06)", -1)),
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("label", null, "Year", -1)),
        _createVNode(_component_VueDatePicker, {
          modelValue: state.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.date) = $event)),
          "year-picker": "",
          clearable: false
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", { class: "buttons" }, [
        _createElementVNode("button", {
          class: "accent",
          onClick: getReport
        }, "Get report")
      ])
    ]),
    (state.showLoading)
      ? (_openBlock(), _createBlock(LoadingDownloadScreen, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})